import * as z from "zod";
//#region src/models/searchParamModel.ts
/**
* `?search=foo` → ILIKE match across all searchables of target entity.
*/
const searchParamModel = z.object({ search: z.string().optional() });
//#endregion
export { searchParamModel };
